// Content Platform — block type registry (Phase 0). The CLOSED set of block types.
//
// Pure data, node-importable (consumed by the build-time content validator). Adding a block type is
// a deliberate, reviewed change here — there is no open-ended "render any JSON" engine. Forbidden
// types (review / rating / award / fabricated trust) intentionally DO NOT EXIST, so they can never
// be authored or rendered (Truth-Before-Reach).

export const BLOCK_TYPES = Object.freeze({
  HERO: 'hero',               // page intro + the single <h1>
  INTRO: 'intro',             // lead paragraph
  RICH_TEXT: 'richText',      // prose section (h2 + paragraphs)
  FEATURE_GRID: 'featureGrid', // unordered {title,text} cards
  STEPS: 'steps',             // ORDERED process / "how it works" (numbered)
  MEDIA: 'media',             // a single image with required alt (asset-backed)
  CTA: 'cta',                 // internal conversion links
  RELATED_CONTENT: 'relatedContent', // internal cross-links
  FAQ: 'faq',                 // schema-ready but INACTIVE (no component, rejected by the validator)
});

// The block types that are RENDERABLE and AUTHORABLE. These cover the foreseeable marketing-page
// needs (About, Fleet, Corporate, Recruitment, Partner, Sustainability, Legal/Campaign landing,
// rich Service) from content modules alone. `faq` is deliberately excluded: schema-defined for
// forward-compatibility but inactive until a later phase ships the FAQ component + FAQPage JSON-LD.
export const ACTIVE_BLOCK_TYPES = Object.freeze([
  BLOCK_TYPES.HERO,
  BLOCK_TYPES.INTRO,
  BLOCK_TYPES.RICH_TEXT,
  BLOCK_TYPES.FEATURE_GRID,
  BLOCK_TYPES.STEPS,
  BLOCK_TYPES.MEDIA,
  BLOCK_TYPES.CTA,
  BLOCK_TYPES.RELATED_CONTENT,
]);
